import { http } from "@next-core/http";

/** 实例对象（动态字段，根据不同对象类型字段不同） */

/**
 * @description 查询服务对象实例列表
 * @endpoint list /api/v1/elevo/objects/:objectId/instances
 */
export const ElevoObjectApi_listServiceObjectInstances = async (objectId, params, options) => /**! @contract easyops.api.llm.elevo_object.ListServiceObjectInstances@1.0.0 */(await http.get(`api/gateway/logic.llm.aiops_service/api/v1/elevo/objects/${objectId}/instances`, {
  ...options,
  params
})).data;
//# sourceMappingURL=listServiceObjectInstances.js.map